var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { connect } from 'react-redux';
// import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles';
// import { Helmet } from 'react-helmet'
import { getTranslation } from 'src/translation';
// import { Icon } from '@material-ui/core'
import { SupportForm } from 'src/components/routes/channel/users/SupportForm';
import { Mutation } from 'react-apollo';
import { addCreateLeadMutation, addCreateLeadVariables } from 'src/gql/zendesk';
import { ErrorDialog } from 'src/components/reusable/ErrorDialog';
import { SuccessDialog } from 'src/components/reusable/SuccessDialog';
var styles = function (theme) { return ({
    content: {
        // width: 134,
        // '@media(max-width: 1024px)': {
        //   width: 60,
        //   borderRadius: `50%`,
        // },
        // height: 50,
        padding: 0,
        margin: '10px 20px',
        position: ' fixed',
        bottom: 0,
        overflow: 'visible',
        opacity: 1,
        border: 0,
        zIndex: 1300,
        letterSpacing: 0.6,
        transitionDuration: 250,
        transitionTimingFunction: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        transitionProperty: 'opacity, top, bottom',
        right: 0,
    },
    buttonWrapper: {
        color: '#FFFFFF !important',
        fill: '#FFFFFF !important',
        display: 'flex',
        padding: '10px 14px',
        borderRadius: '999rem',
        bottom: 0,
        letterSpacing: 0.6,
        fontSize: '1.07143rem',
    },
    supportText: {
        margin: 'auto',
        fontSize: 17,
        marginRight: 2,
        fontWeight: 500,
        '@media(max-width: 1024px)': {
            display: 'none',
        },
    },
}); };
// @ts-ignore
var SupportButton = /** @class */ (function (_super) {
    __extends(SupportButton, _super);
    function SupportButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onSupportFormSubmit = function (values, createLeadReq) { return __awaiter(_this, void 0, void 0, function () {
            var orgId, description, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!values) return [3 /*break*/, 5];
                        orgId = this.props.orgId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        description = "\n        " + (values.description || 'N/A') + "\n\n\n        URL: " + window.location.href + "\n        ";
                        data = {
                            orgId: orgId,
                            body: description,
                            requesterName: values.firstName + " " + values.lastName,
                            requesterEmail: this.props.userEmail || 'N/A',
                            phoneNumber: values.phoneNumber,
                            subject: values.title,
                        };
                        localStorage.setItem('firstName', values.firstName);
                        localStorage.setItem('lastName', values.lastName);
                        if (!!values.phoneNumber) {
                            localStorage.setItem('phoneNumber', values.phoneNumber);
                        }
                        return [4 /*yield*/, createLeadReq(addCreateLeadVariables({
                                type: 'createTicket',
                                payload: data,
                            }))];
                    case 2:
                        _a.sent();
                        this.setState({
                            showSuccessForm: true,
                            isSupportDialogOpen: false,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({
                            error: e_1.networkError && e_1.networkError.result ? e_1.networkError.result.message : e_1.message,
                            isSupportDialogOpen: false,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({
                            isSupportDialogOpen: false,
                        });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            isSupportDialogOpen: false,
            showSuccessForm: false,
            error: null,
        };
        return _this;
    }
    SupportButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, translate = _a.translate, tubeColor = _a.tubeColor, userEmail = _a.userEmail;
        return (React.createElement(React.Fragment, null,
            React.createElement(Mutation, __assign({}, addCreateLeadMutation()), function (createLeadReq) { return (React.createElement("div", { className: classes.content },
                _this.state.isSupportDialogOpen && (React.createElement(SupportForm, { open: _this.state.isSupportDialogOpen, title: translate('support-form-title'), confirmLabel: translate('submit'), userEmail: userEmail, onClose: function (values) { return _this.onSupportFormSubmit(values, createLeadReq); } })),
                React.createElement(ErrorDialog, { open: !!_this.state.error, message: _this.state.error, onClose: function () { return _this.setState({ error: null }); } }),
                React.createElement(SuccessDialog, { open: _this.state.showSuccessForm, tubeColor: tubeColor, onClose: function () {
                        _this.setState({ showSuccessForm: false });
                    }, dialogContent: translate('support-success'), header: translate('success') }))); })));
    };
    SupportButton = __decorate([
        withStyles(styles),
        connect(function (state, ownProps) {
            return __assign(__assign({}, ownProps), { translate: getTranslation(state.translation.lang), tubeColor: state.auth.tube.color, userEmail: state.auth.user.data.email || state.auth.user.email, orgId: state.auth.organization.id });
        }, null)
    ], SupportButton);
    return SupportButton;
}(React.Component));
export default SupportButton;



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/SupportButton.tsx
// module id = 2048
// module chunks = 81